module.exports = __webpack_public_path__ + "static/media/arrow-down-button.77b7daff.png";